import React from 'react';
import styled from 'styled-components';
import { useTitle } from '../../../shared/hooks/useTitle'
import { useArchiveNav } from '../../../shared/hooks/page/useArchiveNav';
import LnbLogoUsernameFixed from './LeftLogoUsernameFixed';
import BigMenuFixed from './BigMenuFixed';

const LeftNavBarFixed: React.FC = () => {
  const { canShow, isOwner, navItems } = useArchiveNav();
  useTitle();

  if (!canShow) return null;

  return (
    <LnbSection>
      <LnbLogoUsernameFixed />
      <LnbMenuContainer>
        {navItems.map((item) =>
          (item.isVisible || isOwner) && (
            <BigMenuFixed
              key={item.path}
              data={item}
            />
          )
        )}
      </LnbMenuContainer>
    </LnbSection>
  )
}

const LnbSection = styled.section`
  width: fit-content;
  min-width: 180px;
  height: 100vh;
  display: flex;
  flex-direction: column;
`;

const LnbMenuContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export default LeftNavBarFixed;
